/* @flow */
import apiRequest from 'lib/apiRequest';

const TranslationActions = {
  translate(text: string, locale: string) {
    return apiRequest(`/translations/${locale}`, 'GET', {
      q: text,
    });
  },
};

export default TranslationActions;



// WEBPACK FOOTER //
// ./src/actions/TranslationActions.js